export default class ShopDiscount {
    /** @type {int} */
    id = 0
    name = ''
    description = ''
    promo_page_url = ''
    edit_url = ''
    edit_label = ''
    error = null
    products_url = ''

    constructor(discount) {
        this.id = parseInt(discount.id)
        this.name = discount.name
        this.description = discount.description
        this.promo_page_url = discount.promo_page_url
        this.edit_url = discount.edit_url
        this.edit_label = discount.edit_label
        this.error = discount.error
        this.products_url = discount.products_url
    }
}